import React from 'react';
import { DOMESTIC, INDIA_COUNTRY_CODE } from '../../constants';

export const DropDownSelect = (props) => {
    const { input, data, dis, meta: { touched, error } } = props;
    if (data) {
        return (
            <div>
                {/* <label htmlFor={label}>{label}</label> */}
                <select {...input} className="form-control" disabled={dis}>
                    <option value="">Select</option>
                    {data.map(p => {
                        if (p.name) {
                            return (
                                <option key={p.name} value={p.id}>
                                    {p.name}
                                </option>
                            );
                        } else if (p.productName) {
                            return (
                                <option key={p.productName} value={p.productName}>
                                    {p.productName}
                                </option>
                            );
                        } else if (!p.id) {
                            return (
                                <option key={p} value={p}>
                                    {p}
                                </option>
                            );
                        }

                    })}
                </select>
                {touched && error && <span>{error}</span>}
            </div>
        );
    } else {
        return (
            <div>
                <select {...input} className="form-control" disabled={dis}>
                    <option value="">No</option>
                </select>
                {touched && error && <span>{error}</span>}
            </div>
        );
    }
}

export const countryDropdown = (props) => {
    const { input, data, dis, meta: { touched, error } } = props;
    if (data) {
        return (
            <div>
                {
                    (props.caseType === DOMESTIC) ?
                        <select {...input} className="form-control" value={INDIA_COUNTRY_CODE} disabled={dis}>
                            <option value="">Select</option>
                            {data.map(p => {
                                return (
                                    <option key={p.countryName} value={p.countryCode}>
                                        {p.countryName}
                                    </option>
                                )
                            })}
                        </select> : <select {...input} className="form-control" disabled={dis}>
                            <option value="">Select</option>
                            {data.map(p => {
                                return (
                                    <option key={p.countryName} value={p.countryCode}>
                                        {p.countryName}
                                    </option>
                                )
                            })}
                        </select>
                }
            </div>
        )
    } else {
        return (
            <div>
                <select {...input} className="form-control" disabled={dis}>
                    <option value="">No</option>
                </select>
                {touched && error && <span>{error}</span>}
            </div>
        );
    }
}